export default {"src":"/_next/static/media/best.ebec7f21.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};